// extracted by mini-css-extract-plugin
export var card = "card-module--card--3Jcob";
export var title = "card-module--title--13TPy";
export var image = "card-module--image--2XI-I";
export var description = "card-module--description--1S4s7";
export var button = "card-module--button--2eLCh";